import Page, { PageProps } from "./Page";

export default Page;

export type { PageProps };
